var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6506 1.979L13.2716 8.20216L14.8211 4.53058L21.6506 1.979Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.30737 1.979L10.6189 8.26111L9.14526 4.53058L2.30737 1.979ZM18.6358 16.4043L16.4042 19.8232L21.1789 21.1369L22.5516 16.4801L18.6358 16.4043ZM1.42316 16.4801L2.78737 21.1369L7.5621 19.8232L5.33052 16.4043L1.42316 16.4801Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29262 10.6273L5.9621 12.6399L10.7032 12.8505L10.5347 7.75572L7.29262 10.6273ZM16.6653 10.6273L13.381 7.69678L13.2716 12.8505L18.0042 12.6399L16.6653 10.6273ZM7.5621 19.8231L10.4084 18.4336L7.94947 16.5136L7.5621 19.8231ZM13.5495 18.4336L16.4042 19.8231L16.0084 16.5136L13.5495 18.4336Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4042 19.8231L13.5495 18.4336L13.7769 20.2946L13.7516 21.0778L16.4042 19.8231ZM7.56213 19.8231L10.2148 21.0778L10.1979 20.2946L10.4084 18.4336L7.56213 19.8231Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2568 15.2841L7.88208 14.5852L9.55787 13.8188L10.2568 15.2841ZM13.701 15.2841L14.4 13.8188L16.0842 14.5852L13.701 15.2841Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56208 19.8233L7.96629 16.4043L5.33051 16.4801L7.56208 19.8233ZM16 16.4043L16.4042 19.8233L18.6358 16.4801L16 16.4043ZM18.0042 12.6401L13.2716 12.8507L13.7095 15.2843L14.4084 13.8191L16.0926 14.5854L18.0042 12.6401ZM7.88208 14.5854L9.5663 13.8191L10.2568 15.2843L10.7031 12.8507L5.96208 12.6401L7.88208 14.5854Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9621 12.6401L7.94947 16.5138L7.8821 14.5854L5.9621 12.6401ZM16.0926 14.5854L16.0084 16.5138L18.0042 12.6401L16.0926 14.5854ZM10.7032 12.8507L10.2568 15.2843L10.8126 18.1559L10.9389 14.3749L10.7032 12.8507ZM13.2716 12.8507L13.0442 14.3665L13.1453 18.1559L13.7095 15.2843L13.2716 12.8507Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7094 15.2844L13.1452 18.156L13.5494 18.4339L16.0084 16.5139L16.0926 14.5854L13.7094 15.2844ZM7.88208 14.5854L7.94945 16.5139L10.4084 18.4339L10.8126 18.156L10.2568 15.2844L7.88208 14.5854Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7516 21.078L13.7769 20.2948L13.5663 20.1096H10.3916L10.1979 20.2948L10.2148 21.078L7.56213 19.8232L8.48845 20.5811L10.3663 21.8864H13.5916L15.4779 20.5811L16.4042 19.8232L13.7516 21.078Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5495 18.4337L13.1452 18.1558H10.8126L10.4084 18.4337L10.1979 20.2947L10.3916 20.1094H13.5663L13.7768 20.2947L13.5495 18.4337Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0042 8.60637L22.72 5.17058L21.6505 1.979L13.5495 7.99163L16.6653 10.6274L21.0695 11.9158L22.0463 10.779L21.6253 10.4758L22.299 9.86111L21.7769 9.4569L22.4506 8.94321L22.0042 8.60637ZM1.24634 5.17058L1.96213 8.60637L1.50739 8.94321L2.18107 9.4569L1.66739 9.86111L2.34107 10.4758L1.92002 10.779L2.88844 11.9158L7.29265 10.6274L10.4084 7.99163L2.30739 1.979L1.24634 5.17058Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0695 11.9155L16.6653 10.6271L18.0042 12.6397L16.0084 16.5134L18.6358 16.4797H22.5516L21.0695 11.9155ZM7.29263 10.6271L2.88842 11.9155L1.42316 16.4797H5.33052L7.94947 16.5134L5.9621 12.6397L7.29263 10.6271ZM13.2716 12.8503L13.5495 7.99133L14.8295 4.53027H9.14526L10.4084 7.99133L10.7032 12.8503L10.8042 14.3829L10.8126 18.1555H13.1453L13.1621 14.3829L13.2716 12.8503Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/Metamask.08fd4e984540dd46d42f3e2b28d7f7e2.svg";
export { ForwardRef as ReactComponent };